import { Platform } from 'react-native';

export const URI_PREFIX__STANDALONE = /(?:exps|https|aviva|avivastaff):\/\/(?:(?:\w+\.)?\w+\.(?:dev|health)\/)?/;
export const URI_PREFIX__WEB = new RegExp(`(?:http|https)://${window?.location?.host}/`);

export const URI_PREFIX = Platform.OS === 'web' ? URI_PREFIX__WEB : URI_PREFIX__STANDALONE;
